import { Helmet } from 'react-helmet'

import { OnboardingBannerSlot } from '@/components/OnboardingBannerSlot'
import { SkeletonRows } from '@/components/ui/skeleton'
import { useCurrentUser } from '../../../../models/user'
import { BusinessTab } from '../AdminSettings/BusinessTab'

export function FleetDetails() {
  const { user, isLoading } = useCurrentUser({ enabled: true })

  function renderContent() {
    if (isLoading || !user) {
      return <SkeletonRows />
    }

    return <BusinessTab business={user.currentOrg.business} />
  }

  return (
    <>
      <Helmet>
        <title>Business info</title>
      </Helmet>
      <div className="flex flex-col gap-5">
        <div className="mb-2 text-2xl font-semibold">Business info</div>
        <OnboardingBannerSlot />
        {renderContent()}
      </div>
    </>
  )
}
